<template>
  <router-view/>
</template>

<script>
export default {
  name: "App",
  mounted() {
    // -R
    if (process.env.NODE_ENV !== 'development') {
      window.onload = function () {
        if (window.versionIdentification) {
          console.log('release time=', window.versionIdentification);
        }
      }
    }
  }
};
</script>

<style>
.el-table-filter__list{
  max-height: 500px;
  overflow: auto;
}
.LockInto{
  position: relative;
 }
.LockInto::before{
   content: '';
   background: #fff;
   color: transparent;
   position: absolute;
   left: 0%;
   top: 50%;
   transform: translateY(-50%);
   width: calc(100%);
   height: 100%;
   animation: mymove 4s 1 forwards;
}
@keyframes mymove
 {
   from {left:0%;}
   to {left:100%;width:calc(0px);}
}
html {
  height: 100%;
}
body {
   font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  padding: 0px;
  margin: 0px;
  height: 100%;
}

.f-h {
  height: 100%;
}
.f-w {
  width: 100%;
}
.sub-title {
  text-align: center;
  color: gray;
  font-family: "Youyuan", "Microsoft YaHei", "宋体", "黑体", sans-serif;
  font-size: 1rem;
  font-weight: 600;
  margin-bottom: 10px;
}
.left {
  text-align: left;
}
.right {
  text-align: right;
}
.center {
  text-align: center;
}
.left-pad {
  margin-left: 0.5rem;
}
.right-pad{
  margin-right: 0.7rem;
}
.top-pad {
  margin-top: 0.5rem;
}
.inline {
  display: inline;
}

.el-container{
  height: 100%;
}
.el-footer {
  color: dimgray;
}
.el-scrollbar__wrap {
  overflow-x: hidden;
}
.el-main {
  -padding-top: 5px;
}

/* 滚动条样式*/

::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 8px;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 8px;
}

::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 0px;
  background: rgba(0, 0, 0, 0.15);
}

::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  border-radius: 0;
  background: rgba(0, 0, 0, 0.1);
}
.toolbar {
  text-align: left;
  padding: 5px 0 5px 0;
}

.condition-thin {
  width: 4rem;
  margin-left: 0.5rem;
}
.condition-input {
  width: 8rem;
  margin-left: 0.5rem;
}

.condition-wide {
  width: 15rem;
  margin-left: 0.5rem;
}

.edit-thin {
  width: 6rem;
}
.edit-input {
  width: 8rem;
}
.edit-wide {
  width: 18rem;
}
.edit-memo {
  width: 24rem;
}

.dotted-border {
  border: 1px dashed lightgray;
}
.no-border {
  border: none;
}
.main-table {
  min-height: 460px;
}
.el-divider--horizontal{
  margin: 0px !important;
}
.edit-section{
  padding-left: 2rem;
  padding-bottom: 1rem;
}
.edit-checkbox{
  margin-left: -1.1rem;
}
.el-loading-text{
  color: #409EFF !important;
  font-size: 20px  !important;
}
.padding > .el-card__body{
  padding: 0 !important;
}
.red {
  color: red;
}

.noBorder td ,.noBorder th{
  border: none !important;
}
.refund-border {
    border: 2px dashed red;
}

  /* .flex  .el-card__body{
  display: flex !important;
  align-items: center;
  justify-content: space-between !important;
} */

/* 没安装打印机时，报错的message防止和支付成功的message重叠 */
  .message-error-defined {
    margin-top: 80px
  }
/* $message里showClose 关闭X的样式 */
.el-message__closeBtn {
  font-size: 18px;
  color: red;
}
</style>
